import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { FAMILY_INFORMATION_API } from "../api";
import {
  setIsNewForFamilyInformation,
  setIsDataChangedForFamily,
  addErrorMessage,
  addSuccessMessage,
  setFamilyInformationData,
} from "../slice";

export const useFamilyInfo = ({ hasEditAccess, errors }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data, isNew, isDataChanged } = useSelector((state) => state.FamilyInformation);

  const { mutateAsync: addFamilyInformation } = useMutation((body) =>
    FAMILY_INFORMATION_API.AddFamilyInformation(body)
  );

  const { mutateAsync: editFamilyInformation } = useMutation((body) =>
    FAMILY_INFORMATION_API.EditFamilyInformation(body)
  );

  const { mutate: getFamilyInformation } = useMutation(
    () => FAMILY_INFORMATION_API.GetFamilyInformation(),
    {
      onSuccess: ({ data }) => {
        if (data.success && data.data) {
          dispatch(setFamilyInformationData(data.data));
        }
      },
    }
  );

  const countErrors = (errors) => {
    let result = 0;
    Object.keys(errors).forEach((item) => {
      if (errors[item].length !== 0) result += 1;
    });
    return result;
  };

  const handleSubmit = async (route) => {
    if (countErrors(errors) === 0)
      if (hasEditAccess && isDataChanged) {
        if (isNew) {
          await addFamilyInformation(data, {
            onSuccess: ({ data }) => {
              if (data.success) {
                dispatch(setIsNewForFamilyInformation(false));
                dispatch(addSuccessMessage(data?.message));
                navigate(route);
              }
            },
            onSettled: () => {
              dispatch(setIsDataChangedForFamily(false));
            },
            onError: ({ response }) => {
              dispatch(addErrorMessage(response));
            },
          });
        } else {
          await editFamilyInformation(data, {
            onSuccess: ({ data }) => {
              if (data.success) {
                dispatch(addSuccessMessage(data?.message));
                navigate(route);
              }
            },
            onSettled: () => {
              dispatch(setIsDataChangedForFamily(false));
            },
            onError: ({ response }) => {
              dispatch(addErrorMessage(response));
            },
          });
        }
      } else {
        navigate(route);
      }
  };
  return { handleSubmit, getFamilyInformation };
};
